module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "switch-heading"
  }, [_c('div', {
    staticClass: "checkbox-column",
    attrs: {
      "title": _vm.checkboxName
    }
  }, [_c('v-checkbox', {
    staticClass: "compact",
    attrs: {
      "label": _vm.schema.label,
      "hide-details": ""
    },
    model: {
      value: (_vm.checkboxValue),
      callback: function($$v) {
        _vm.checkboxValue = $$v
      },
      expression: "checkboxValue"
    }
  })], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.checkboxValue) ? _c('div', {
    staticStyle: {
      "margin-bottom": "-10px"
    }
  }, [_c('FormBlock', {
    ref: "theInput",
    attrs: {
      "horizontal": _vm.schema.horizontal,
      "schema": _vm.modifiedSchema,
      "value": _vm.value,
      "context": _vm.context
    },
    on: {
      "change": _vm.emitInputChange
    }
  })], 1) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4b98b370"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/forms/blocks/SwitchHeadingControl.vue
// module id = 2536
// module chunks = 1